(function () {
  if (!('IntersectionObserver' in window)) return;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduceMotion) return;

  var observer = new IntersectionObserver(
    function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is--revealed');
          obs.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 0.1,
      rootMargin: '0px 0px -5% 0px'
    }
  );

  function observeSections(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('.t4s-section-inner:not(.scroll-animate)').forEach(function (el) {
      el.classList.add('scroll-animate');

      var rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight && rect.bottom > 0) {
        el.classList.add('is--revealed');
        return;
      }

      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      observeSections();
    });
  } else {
    observeSections();
  }

  document.addEventListener('shopify:section:load', function (e) {
    observeSections(e.target);
  });
})();
